import { render } from "./PercentageIncomesBySource.vue?vue&type=template&id=0fdf8835"
import script from "./PercentageIncomesBySource.vue?vue&type=script&lang=js"
export * from "./PercentageIncomesBySource.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__